import React, { useEffect } from "react";
import "./style.css";

export default function AddItems({
    open,
    onClose,
    title,
    children,
    className = "",
    disableBackdrop = false,
    hideCloseButton = false,
    // Add new prop for customizable width
    maxWidth = "600px",
}) {
    useEffect(() => {
        if (!open) return;
        const previous = document.body.style.overflow;
        if (!disableBackdrop) {
            document.body.style.overflow = "hidden";
        }
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);


        return () => {
            document.body.style.overflow = previous;
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onClose]);


    if (!open) return null;

    // ... (disableBackdrop code remains the same) ...

    return (
        <div className="modal-overlay" aria-modal="true" role="dialog">
            <div className="modal-backdrop" onClick={onClose} data-testid="modal-overlay" />

            {/* Apply the new maxWidth prop here */}
            <div className="modal-container" style={{ maxWidth }}>
                <div className={`modal-box ${className}`}>
                    {title && (
                        <div className="modal-header">
                            <h2 id="modal-title">{title}</h2>
                            {!hideCloseButton && (
                                <button
                                    onClick={onClose}
                                    aria-label="Close modal"
                                    className="modal-close"
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    )}
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
}